export const GET_ALL_PRODUCT_BY_CATE_SLUG = "GET_ALL_PRODUCT_BY_CATE_SLUG";
export const GET_PRODUCT_BY_SLUG = "GET_PRODUCT_BY_SLUG";
export const GET_PRODUCT_BY_NAME = "GET_PRODUCT_BY_NAME";
export const GET_PRODUCT_BY_SLUG_COLOR = "GET_PRODUCT_BY_SLUG_COLOR";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_NEW = "GET_PRODUCTS_NEW";
export const GET_PRODUCTS_HOT = "GET_PRODUCTS_HOT";
